import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@evaneos/b2b-ui';
import CloseOutlinedIcon from '@evaneos/b2b-ui/icons/CloseOutlined';
import { useIntl } from 'react-intl';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export function AppointmentCancelConfirmDialog({ isOpen, onClose, onConfirm }: Readonly<Props>) {
    const { formatMessage } = useIntl();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="cancel-appointment-dialog-title"
            slotProps={{ paper: { sx: { padding: 3, maxWidth: 560, borderRadius: 2 } } }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <DialogTitle
                    id="cancel-appointment-dialog-title"
                    variant="h2"
                    sx={{ p: 0, fontWeight: 700 }}
                >
                    {formatMessage({ id: 'appointment.cancel_dialog.title' })}
                </DialogTitle>
                <IconButton onClick={onClose} aria-label={formatMessage({ id: 'global.close' })}>
                    <CloseOutlinedIcon />
                </IconButton>
            </Box>
            <DialogContent sx={{ px: 0 }}>
                <Alert severity="warning">
                    {formatMessage({ id: 'appointment.cancel_dialog.warning' })}
                </Alert>
            </DialogContent>
            <DialogActions sx={{ px: 0, gap: 2, justifyContent: 'flex-start' }}>
                <Button variant="outlined" onClick={onClose}>
                    {formatMessage({ id: 'appointment.cancel_dialog.back_button' })}
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    data-spec-id="appointment-cancel-confirm-button"
                    onClick={onConfirm}
                >
                    {formatMessage({ id: 'appointment.cancel_dialog.confirm_button' })}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
